// jQuery
window.$ = window.jQuery = require('jquery');

// bootstrap
require('bootstrap');
require('bootstrap-datepicker');

// inputmask
require('inputmask');

// carbarn
window.carbarn = require('./carbarn.js');